import { MAX_NUM_OF_PAYMENT_ATTEMPTS } from "_constants/billing";
import { STORAGE_KEYS } from "_constants/storage";
import * as bcrypt from "_helpers/bcrypt";

import { restoreLocalValue, storeLocalValue } from "./storage";

export const checkIfNumberOfPaymentAttemptsExceeded = () => {
  const billingCounter = restoreLocalValue(STORAGE_KEYS.billingCounter);
  return billingCounter >= MAX_NUM_OF_PAYMENT_ATTEMPTS;
};

export const checkIfPaymentMethodNotChanged = async (paymentMethodData) => {
  const billingHash = restoreLocalValue(STORAGE_KEYS.billingHash);

  if (!billingHash) {
    return false;
  }

  const cardDataString = JSON.stringify(paymentMethodData);
  return await bcrypt.compare(cardDataString, billingHash);
};

export const increaseBillingCounter = () => {
  const billingCounter = restoreLocalValue(STORAGE_KEYS.billingCounter) || 0;
  storeLocalValue(STORAGE_KEYS.billingCounter, billingCounter + 1);
};

export const resetBillingCounter = () => {
  storeLocalValue(STORAGE_KEYS.billingCounter, 0);
};

export const createBillingHash = async (paymentMethodData) => {
  const cardDataString = JSON.stringify(paymentMethodData);
  const billingHash = await bcrypt.createHash(cardDataString);
  storeLocalValue(STORAGE_KEYS.billingHash, billingHash);
};
